// extracted by mini-css-extract-plugin
module.exports =  {"root":"tN8xdNr","partner-logo-img":"yDTp5Ml","partnerLogoImg":"yDTp5Ml"};